export default __webpack_public_path__ + "static/media/10_of_clubs.1e849b92.png";